import albacore from '../../../media/about/fishing/albacore.jpeg';
import bluefinBlood from '../../../media/about/fishing/bluefin_blood.jpeg';
import bluefinGil from '../../../media/about/fishing/bluefin_gil.jpeg';
import gianlucaBluefish from '../../../media/about/fishing/gianluca_bluefish.jpeg';
import gianlucaDogFish from '../../../media/about/fishing/gianluca_dog_fish.jpeg';
import giantBluefin from '../../../media/about/fishing/giant_bluefin.jpeg';
import giantStripedBass from '../../../media/about/fishing/giant_striped_bass.jpeg';
import juliaLargemouthBass from '../../../media/about/fishing/julia_largemouth_bass.jpeg';
import rolandDogFish from '../../../media/about/fishing/roland_dog_fish.jpeg';
import sandTigerShark from '../../../media/about/fishing/sand_tiger_shark.png';
import sandTigerSharkDay from '../../../media/about/fishing/sand_tiger_shark_day.jpg';
import stripedBass from '../../../media/about/fishing/striped_bass.jpeg';
import tunaBoat from '../../../media/about/fishing/tuna_boat.jpg';
import tunaButcher from '../../../media/about/fishing/tuna_butcher.jpg';
import stripedBassBoat from '../../../media/about/fishing/striped_bass_boat.jpg';
import sandTigerSharkBeach from '../../../media/about/fishing/sand_tiger_shark_beach.jpg';

const fishingStory = {
  id: "fishing",
  title: "Fishing",
  heroImage: rolandDogFish,
  gradient: "linear-gradient(135deg, #0077be 0%, #00a8cc 100%)",

  description: `Although I’ve never excelled at fishing, I have always enjoyed going out with my stepbrothers when I can get the opportunity.  Every season, we head into the saltwater shores and bays of Long Island with the intention of discovering a new fish species or to bring back dinner for our family of eight!`,

  gallery: [
    { type: 'image', src: tunaBoat, alt: 'Bluefin tuna with my stepbrothers' },
    { type: 'image', src: giantBluefin, alt: '200lb Bluefin tuna' },
    { type: 'image', src: tunaButcher, alt: 'Breaking down a tuna' },
    { type: 'image', src: bluefinBlood, alt: 'Another Bluefin tuna' },
    { type: 'image', src: bluefinGil, alt: 'Another Bluefin' },
    { type: 'image', src: stripedBassBoat, alt: 'Striped bass on the boat' },
    { type: 'image', src: giantStripedBass, alt: 'Giant striped bass' },
    { type: 'image', src: stripedBass, alt: 'Dual striper catch' },
    { type: 'image', src: sandTigerSharkBeach, alt: 'Sand tiger shark on the beach at night' },
    { type: 'image', src: sandTigerShark, alt: 'Sand tiger shark at night' },
    { type: 'image', src: sandTigerSharkDay, alt: 'Sand tiger catch on fourth of July' },
    { type: 'image', src: albacore, alt: 'Albacore tuna' },
    { type: 'image', src: juliaLargemouthBass, alt: 'Julia with largemouth bass' },
    { type: 'image', src: gianlucaBluefish, alt: 'Bluefish' },
    { type: 'image', src: gianlucaDogFish, alt: 'Dogfish' },
    { type: 'image', src: rolandDogFish, alt: 'Another Dogfish' }
  ]
};

export default fishingStory;